// extracted by mini-css-extract-plugin
export default {"checkbox-group":"EnumField_checkbox-group__XHhdV"};